import React from 'react';
import { Button } from '@gerdau/hefesto';
import { BottomButtons, BottomContainer, BottomSummary } from './styles';

interface BottonProps {
  name: string;
  text: string;
  fn: () => void;
  fullWidth?: boolean;
  disabled?: boolean;
  loading?: boolean;
}

interface Props {
  children?: React.ReactNode;
  thirdBtn?: BottonProps;
  previousBtn: BottonProps;
  nextBtn: BottonProps;
}

const BottomActionBar = ({
  children,
  nextBtn,
  previousBtn,
  thirdBtn
}: Props) => {
  return (
    <BottomContainer>
      <BottomSummary>{children}</BottomSummary>

      <BottomButtons>
        {thirdBtn && (
          <Button
            name={thirdBtn.name}
            variant="secondary"
            onClick={thirdBtn.fn}
            fullWidth={!!thirdBtn.fullWidth}
            disabled={thirdBtn.disabled}
            loading={thirdBtn.loading}
            style={{ width: '172px' }}
          >
            {thirdBtn.text}
          </Button>
        )}
        <Button
          name={previousBtn.name}
          variant="secondary"
          onClick={previousBtn.fn}
          fullWidth={!!previousBtn.fullWidth}
          disabled={previousBtn.disabled}
          loading={previousBtn.loading}
          style={{ height: '48px' }}
        >
          {previousBtn.text}
        </Button>
        <Button
          name={nextBtn.name}
          onClick={nextBtn.fn}
          fullWidth={!!nextBtn.fullWidth}
          disabled={nextBtn.disabled}
          loading={nextBtn.loading}
          style={{ height: '48px' }}
        >
          {nextBtn.text}
        </Button>
      </BottomButtons>
    </BottomContainer>
  );
};

export default BottomActionBar;
